

import React  from "react";
import {
	TabContent,
	TabPane,
	Nav,
	NavItem,
	NavLink,
	Row,
	Col,
	Button,
	Label,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	UncontrolledTooltip,
	Popover,
	PopoverHeader,
	PopoverBody,
} from "reactstrap";
import moment from "moment";
import {
	AvForm,
	AvField,
	AvGroup,
	AvInput,
	AvRadioGroup,
	AvRadio,
	AvFeedback,
} from "availity-reactstrap-validation";

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";









// 

const RequiredTag = ({required = false}) =><span style={{ display:required ? undefined :"none", color: "red" }}>*</span>;

const IsBoolean = (value = false) => [true , false].includes(value)



const OptionMapping = ({option = []}) =>{
    return (
        <>
        <option>Please Select</option>
        {
            Array.isArray(option) && 
            option.map((item , i)=><option key={i} value={item} >{item}</option>)
        }
        </>
    )
}




const defaultProps = {
    field_required:false,
    field_type:"TEXT",
    sub_fields:[],
    field_name:"",
    onChange:()=>{}
}





const TextInput = (props = defaultProps) => {
    let name = props.field_name && props.field_name.replace(/ /g ,"_"),
        label = props.field_name || '',
        required = IsBoolean(props.field_required) ? props.field_required : false,
        value = props.field_value || "";

    const onFieldValueChange = (e) =>{
        e.persist();
        props.onChange && props.onChange(e , props) 
    }
  return (
    <Col xs="12" md="4" className="position-relative">
      <Label>
        {label} <RequiredTag required={required} />
      </Label>
      <AvField
        type="text"
        // label="First Name"
        name={`${name}`}
        placeholder={`Enter ${label}`}
        onChange={onFieldValueChange} 
        value={value}
        errorMessage="Required"
        required={required}
      />
    </Col>
  );
};


const Dropdown = (props = defaultProps) => {
        let name = props.field_name && props.field_name.replace(/ /g ,"_"),
        label = props.field_name || '',
        required = IsBoolean(props.field_required) ? props.field_required : false,
        value = props.field_value || "";

    const onFieldValueChange = (e) =>{
        e.persist();
        props.onChange && props.onChange(e , props) 
    }
  return (
    <Col xs="12" md="4" className="position-relative">
      <Label> {label} <RequiredTag required={required} /> </Label>
      <AvField
        type="select"
        name={name}
        // label={label}
        placeholder="Select Title"
        onChange={onFieldValueChange}
        value={value}
        errorMessage="Required"
        required={required}
      >
        {
            props.sub_fields && Array.isArray(props.sub_fields)
            ? <OptionMapping option={props.sub_fields} />
            : <></>
        }
      </AvField>
    </Col>
  );
};


const YESORNO = (props = defaultProps) => {
        let name = props.field_name && props.field_name.replace(/ /g ,"_"),
        label = props.field_name || '',
        required = IsBoolean(props.field_required) ? props.field_required : false,
        value = props.field_value || "";

    const onFieldValueChange = (e) =>{
        e.persist();
        props.onChange && props.onChange(e , props) 
    }
  return (
    <Col xs="12" md="4">
      <AvRadioGroup
        label={label}
        name={name}
        value={value}
        onChange={onFieldValueChange}
      >
        <AvRadio label="Yes" value="yes" onClick={()=>{}} />
        <AvRadio label="No" value="no" onClick={()=>{}} />
      </AvRadioGroup>
    </Col>
  );
};




const Date = (props = defaultProps) => {
        let name = props.field_name && props.field_name.replace(/ /g ,"_"),
        label = props.field_name || '',
        required = IsBoolean(props.field_required) ? props.field_required : false,
        value = props.field_value || "";

    const onFieldValueChange = (e) =>{
        e.persist();
        props.onChange && props.onChange(e , props) 
    }
  return (
    <Col xs="12" md="4" className="position-relative">
      <div className="form-group">
        <label htmlFor={name}>{label} <RequiredTag required={required} /> </label>
        <Datetime
          dateFormat="DD-MM-YYYY"
          timeFormat={false}
        //   closeOnSelect={true}
          // value={}
          inputProps={{
            placeholder: "Select Date",
            required:required,
            name:name,
            id:name,
            value
          }}
          onChange={onFieldValueChange}
          // disableOnClickOutside
          isValidDate={(current) =>
            current.isBefore(
                moment(new Date()).subtract(
                    16,
                    "years"
                )
            )
        }
        />
      </div>
    </Col>
  );
};


const TextArea = (props = defaultProps) => {
        let name = props.field_name && props.field_name.replace(/ /g ,"_"),
        label = props.field_name || '',
        required = IsBoolean(props.field_required) ? props.field_required : false,
        value = props.field_value || "";

    const onFieldValueChange = (e) =>{
        e.persist();
        props.onChange && props.onChange(e , props) 
    }
  return (
    <Col xs="12" md="6" className="position-relative mt-3">
      <AvField
        type="textarea"
        name={name}
        label={label}
        placeholder={""}
        onChange={onFieldValueChange}
        id={name}
        required={required}
        value={value}
      ></AvField>
    </Col>
  );
};



export default {
    TEXTAREA : React.memo(TextArea),
    TEXT : React.memo(TextInput),
    MULTIPLECHECKBOX : React.memo(TextInput),
    CHECKBOX : React.memo(TextInput),
    RADIO : React.memo(TextInput),
    DATE : React.memo(Date),
    DROPDOWN : React.memo(Dropdown),
    MULTIPLECHOICE : React.memo(TextInput),
    "YES/NO" : React.memo(YESORNO),
    NUMBER : React.memo(TextInput)
}








/*

0
: 
"TEXTAREA"
1
: 
"TEXT"
2
: 
"MULTIPLECHECKBOX"
3
: 
"CHECKBOX"
4
: 
"RADIO"
5
: 
"EDITOR"
6
: 
"DATE"
7
: 
"DROPDOWN"
8
: 
"MULTIPLECHOICE"
9
: 
"YES/NO"
10
: 
"NUMBER"

*/